import { createApi } from "@reduxjs/toolkit/dist/query/react";
import baseQueryWithReauth from "../../utils/interceptorsToken";
import { authService } from "./authServices";

export const tutorService = authService.injectEndpoints({
    reducerPath: 'tutorService',
    endpoints: (builder) => {
        return {
            getAllTutor: builder.query({
                query: () => {
                    return {
                        url: '/tutor/get-all-tutor',
                    };
                },
                providesTags: ['USER']
            }),
            getTutorDetail: builder.query({
                query: (id) => {
                    return {
                        url: `/tutor/get-tutor-detail/${id}`,
                    };
                },
                providesTags: ['USER']
            }),
            getTutorComment: builder.query({
                query: (id) => {
                    return {
                        url: `/tutor/get-tutor-comment/${id}`,
                    };
                },
                providesTags: ['USER']
            }),
            becomeTutor: builder.mutation({
                query: (data) => {
                    return {
                        url: '/tutor/become-tutor',
                        method: 'POST',
                        body: data,
                    };
                },
                invalidatesTags: ['USER'],
            }),
            bookingTutor: builder.mutation({
                query: (data) => {
                    return {
                        url: '/tutor/booking-tutor',
                        method: 'POST',
                        body: data,
                    };
                },
                invalidatesTags: ['USER'],
            }),
            commentTutor: builder.mutation({
                query: (data) => {
                    return {
                        url: '/tutor/comment-tutor',
                        method: 'POST',
                        body: data,
                    };
                },
                invalidatesTags: ['USER'],
            }),
        };
    }
});

export const { useBecomeTutorMutation, useGetAllTutorQuery, useBookingTutorMutation, useCommentTutorMutation, useGetTutorDetailQuery, useGetTutorCommentQuery } = tutorService;
